import React, { useState } from 'react';
import './DuplicateSubscriptionsModal.css';

function DuplicateSubscriptionsModal({ duplicates, onClose, onConfirm, loading }) {
  const [selectedAction, setSelectedAction] = useState('add_books');

  const handleConfirm = () => {
    if (!selectedAction) {
      alert('בחר אפשרות');
      return;
    }
    onConfirm(selectedAction);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content duplicate-modal" onClick={(e) => e.stopPropagation()}>
        <h2>⚠️ לקוחות קיימים עם מנוי פעיל</h2>
        
        <div className="duplicate-list">
          <p style={{ color: '#666', marginBottom: '15px' }}>
            נמצאו {duplicates.length} לקוחות שכבר קיימים במערכת עם מנוי פעיל.
            <br/>
            בחר כיצד לטפל בהם:
          </p>

          <div className="duplicates-items">
            {duplicates.map((dup, idx) => (
              <div key={idx} className="duplicate-item">
                <strong>{dup.name}</strong> ({dup.identity_id})
                <div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                  • ספרים נוכחיים: {dup.currentBooks}
                  <br/>
                  • ספרים חדשים: {dup.newBooks}
                  <br/>
                  • סיום מנוי נוכחי: {dup.currentEndDate}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="action-options">
          <label className="option-radio">
            <input
              type="radio"
              name="action"
              value="add_books"
              checked={selectedAction === 'add_books'}
              onChange={(e) => setSelectedAction(e.target.value)}
              disabled={loading}
            />
            <span className="option-text">
              <strong>הוסף ספרים למנוי קיים</strong>
              <div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                מוסיף את כמות הספרים החדשה למנוי הקיים.
                <br/>
                (לדוגמה: 4 + 4 = 8 ספרים)
              </div>
            </span>
          </label>

          <label className="option-radio">
            <input
              type="radio"
              name="action"
              value="extend_time"
              checked={selectedAction === 'extend_time'}
              onChange={(e) => setSelectedAction(e.target.value)}
              disabled={loading}
            />
            <span className="option-text">
              <strong>הארך את תקופת המנוי</strong>
              <div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                משנה את סוף המנוי לתאריך החדש.
                <br/>
                (כמות הספרים תתעדכן לכמות החדשה)
              </div>
            </span>
          </label>
        </div>

        <div className="modal-actions">
          <button
            className="btn btn-primary"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? 'עיבוד...' : 'אישור'}
          </button>
          <button
            className="btn btn-secondary"
            onClick={onClose}
            disabled={loading}
          >
            ביטול
          </button>
        </div>
      </div>
    </div>
  );
}

export default DuplicateSubscriptionsModal;
